import { Component } from '@angular/core';

@Component({
    selector: 'user',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class UserComponent {}
